/**
 * Price Range Slider
 * Handles the dual-range slider interactivity for price filtering
 * Only applies to collection filter sidebar
 */
/**
 * Price Range Slider
 * Handles the dual-range slider interactivity for price filtering
 * Only applies to collection filter sidebar
 */
(function() {
  'use strict';

  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  function initPriceRangeSliders() {
    const sliders = document.querySelectorAll('[data-price-range-slider]');
    
    sliders.forEach(function(slider) {
      const minSlider = slider.querySelector('[data-price-range-min]');
      const maxSlider = slider.querySelector('[data-price-range-max]');
      const progress = slider.querySelector('[data-price-range-progress]');
      
      // Find the associated input fields
      const container = slider.closest('.collection-filters__filter-range');
      if (!container) return;
      
      const minInput = container.querySelector('[data-price-input-min]');
      const maxInput = container.querySelector('[data-price-input-max]');
      
      if (!minSlider || !maxSlider || !progress || !minInput || !maxInput) return;

      // Find the parent form
      const form = slider.closest('form');
      
      const rangeMax = parseFloat(slider.dataset.rangeMax) || 1000;
      
      // Detect RTL layout
      const isRTL = document.documentElement.dir === 'rtl';
      
      // Update progress bar based on slider values
      function updateProgress() {
        const minVal = parseFloat(minSlider.value) || 0;
        const maxVal = parseFloat(maxSlider.value) || rangeMax;
        
        // Calculate percentages
        const startPercent = (minVal / rangeMax) * 100;
        const endPercent = ((rangeMax - maxVal) / rangeMax) * 100;
        
        // For RTL, the visual positions are swapped
        if (isRTL) {
          progress.style.right = startPercent + '%';
          progress.style.left = endPercent + '%';
        } else {
          progress.style.left = startPercent + '%';
          progress.style.right = endPercent + '%';
        }
      }
      
      // Debounced form submission
      const debouncedSubmit = debounce(function() {
        if (form) {
          // Use requestSubmit to trigger any submit event listeners attached to the form
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
      }, 700); // 700ms delay to allow for dragging/typing
      
      // Sync input to slider value and trigger filter
      function syncInputToSlider(type) {
        let inputElement;
        
        if (type === 'min') {
          let value = parseFloat(minSlider.value);
          const maxValue = parseFloat(maxSlider.value);
          
          // Prevent min from exceeding max
          if (value >= maxValue) {
            value = maxValue - 1;
            if (value < 0) value = 0;
            minSlider.value = value;
          }
          
          minInput.value = Math.round(value);
          inputElement = minInput;
        } else {
          let value = parseFloat(maxSlider.value);
          const minValue = parseFloat(minSlider.value);
          
          // Prevent max from going below min
          if (value <= minValue) {
            value = minValue + 1;
            if (value > rangeMax) value = rangeMax;
            maxSlider.value = value;
          }
          
          maxInput.value = Math.round(value);
          inputElement = maxInput;
        }
        
        updateProgress();
        debouncedSubmit();
      }
      
      // Sync slider to input value
      function syncSliderToInput(type) {
        if (type === 'min') {
          let value = parseFloat(minInput.value) || 0;
          const maxValue = parseFloat(maxSlider.value);
          value = Math.max(0, Math.min(value, maxValue - 1));
          minSlider.value = value;
        } else {
          let value = parseFloat(maxInput.value) || rangeMax;
          const minValue = parseFloat(minSlider.value);
          value = Math.max(minValue + 1, Math.min(value, rangeMax));
          maxSlider.value = value;
        }
        updateProgress();
        debouncedSubmit();
      }
      
      // Event listeners for sliders - update on drag
      minSlider.addEventListener('input', function() {
        syncInputToSlider('min');
      });
      
      maxSlider.addEventListener('input', function() {
        syncInputToSlider('max');
      });
      
      // Sync slider position when inputs change
      minInput.addEventListener('input', function() {
        syncSliderToInput('min');
      });
      
      maxInput.addEventListener('input', function() {
        syncSliderToInput('max');
      });
      
      // Initialize progress bar on load
      updateProgress();
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceRangeSliders);
  } else {
    initPriceRangeSliders();
  }
  
  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    initPriceRangeSliders();
  });
})();